import React from 'react';
import RentalHero from './RentalHero';
import RentalFeatures from './RentalFeatures';
import RentalContact from './RentalContact';

export default function RentalSection() {
  return (
    <section className="-mt-24"> {/* Negative margin to offset header height */}
      <RentalHero />
      <div className="bg-white">
        <RentalFeatures />
        <RentalContact />
      </div>
    </section>
  );
}